import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { INITIAL_DATE, INITIAL_PAGINATION, NOT_COMPLETE_TAB } from "./constant";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import { constructDataFilter, formGroupManagementClaim, getTableColumns } from "./config";
import { defaultTableChange } from "../../../modules/custom/customTable";
import ManagementClaimDetail from "./managementClaimDetail";
import { fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";
import moment from "moment";
import ManagementClaimFilter from "./managementClaimFilter";

export default class ManagementClaimTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        startDate: INITIAL_DATE,
        endDate: INITIAL_DATE,
      },
      pagination: INITIAL_PAGINATION,
      dataTable: [],
      detail: {
        visible: false,
        activityType: null,
        data: null,
      },
      skipNextFetch: false,
      isDisableSpesificField: null,
      submitedFilter: null,
      filterVisible: false,
    };
  }

  componentDidMount() {
    if (this.props.selectedCabang?.value) {
      this.fetchData(
        {
          startTanggalClaim: INITIAL_DATE,
          endTanggalClaim: INITIAL_DATE,
        },
        5,
        1,
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevProps?.selectedCabang?.value;
    const currCabang = this.props?.selectedCabang?.value;
    if (prevCabang !== currCabang) {
      this.resetPagination();
      this.fetchData(
        {
          startTanggalClaim: INITIAL_DATE,
          endTanggalClaim: INITIAL_DATE,
        },
        5,
        1,
      );
    }
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;
    if (
      (currPagination.page !== prevPagination.page ||
        currPagination.limit !== prevPagination.limit) &&
      !this.state.skipNextFetch
    ) {
      this.refetch(currPagination.limit, currPagination.page);
    }
    if (this.state.skipNextFetch) {
      this.setState({
        skipNextFetch: false,
      });
    }
  }

  resetPagination = () => {
    this.setState((prev) => ({
      ...prev,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: true,
    }));
  };

  fetchData = async (filter = {}, limit, page) => {
    const { onTriggerLoading, setError, selectedCabang, tabCode } = this.props;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getManagementClaimMainPage,
      menuName: "Management Claim",
      setError: setError,
      args: {
        kodeCabang: selectedCabang?.value,
        limit: limit,
        page: page,
        ...filter,
        claimManagementStatus: tabCode,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleSearchChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: value,
      },
    }));
  };

  handleSearch = async () => {
    const { search } = this.state;
    const { onTriggerLoading } = this.props;

    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
        skipNextFetch: true,
      }),
      () => {
        onTriggerLoading();
        this.fetchData(
          {
            startTanggalClaim: search.startDate,
            endTanggalClaim: search.endDate,
          },
          this.state.pagination.limit,
          1,
        );
        onTriggerLoading();
      },
    );
  };

  getTableConfig = () => {
    const { tabCode, userAccess } = this.props;
    const { dataTable } = this.state;
    return getTableColumns({
      tab: tabCode,
      onShowDetail: this.handleDetailVisibility,
      dataTable: dataTable,
      userAccess: userAccess,
    });
  };

  handleChangePage = (tableState) => {
    const page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    const limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
        page: 1,
        limit: limit,
      },
    }));
  };

  handleDetailVisibility = (activityType, data, disableSpesificField) => {
    this.setState((prev) => ({
      ...prev,
      detail: {
        visible: !prev.detail.visible,
        activityType: activityType || null,
        data: data || null,
      },
      isDisableSpesificField:
        disableSpesificField === undefined ? null : disableSpesificField,
    }));
  };

  handleRefresh = () => {
    this.setState(
      (prev) => ({
        ...prev,
        skipNextFetch: true,
      }),
      () => {
        this.refetch(this.state.pagination.limit, this.state.pagination.page);
      },
    );
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({ ...prev, filterVisible: !prev.filterVisible }));
  };

  handleSubmitFilter = (filter) => {
    this.setState(
      (prev) => ({
        ...prev,
        submitedFilter: filter,
        search: {
          startDate: null,
          endDate: null,
        },
        pagination: {
          ...prev.pagination,
          page: 1,
          totalData: 0,
        },
        skipNextFetch: true,
      }),
      async () => {
        const payload = constructDataFilter(filter);
        await this.fetchData(payload, this.state.pagination.limit, 1);
        this.handleFilterVisibility();
      },
    );
  };

  refetch = (limit, page) => {
    const filter = constructDataFilter(this.state.submitedFilter);
    const {
      startDate: searchStartDate,
      endDate: searchEndDate,
      ...restSearch
    } = this.state.search;
    const {
      startDate: filterStartDate,
      endDate: filterEndDate,
      ...restFilter
    } = filter;

    const payload = {
      ...(restSearch || {}),
      ...(restFilter || {}),
      startTanggalClaim: searchStartDate || filterStartDate,
      endTanggalClaim: searchEndDate || filterEndDate,
    };

    this.fetchData(payload, limit, page);
  };

  render() {
    const { tabCode, userAccess } = this.props;
    const {
      search,
      dataTable,
      pagination,
      detail,
      isDisableSpesificField,
      filterVisible,
      submitedFilter,
    } = this.state;
    return (
      <React.Fragment>
        <FlexView
          style={{ marginBottom: "15px", justifyContent: "space-between" }}
        >
          <FlexView vAlignContent="center" style={{ gap: "15px" }}>
            <p className="margin-bottom-15px">Periode</p>
            <SimpleDate
              id="id_start_date_management_claim"
              date={search.startDate}
              maxDate={search.endDate}
              onChange={(value) =>
                this.handleSearchChange(
                  "startDate",
                  moment(value).format("DD-MM-YYYY"),
                )
              }
            />
            <p className="margin-bottom-15px">s/d</p>
            <SimpleDate
              id="id_end_date_management_claim"
              date={search.endDate}
              onChange={(value) =>
                this.handleSearchChange(
                  "endDate",
                  moment(value).format("DD-MM-YYYY"),
                )
              }
            />
            <SimpleButton
              className="margin-bottom-15px"
              text="Cari"
              onClick={this.handleSearch}
            />
          </FlexView>
          <SimpleButton
            category="action_button"
            onClick={() => this.handleFilterVisibility()}
            className="btn background-red margin-bottom-15px"
            icon={
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
            }
          />
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={this.getTableConfig()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleChangeRowsPerPage,
          )}
          footerAdditionalButtons={
            NOT_COMPLETE_TAB.includes(tabCode) &&
            userAccess?.createAccess && (
              <SimpleButton
                text="TAMBAH"
                icon={<i className="fa fa-plus margin-right-10px" />}
                onClick={() =>
                  this.handleDetailVisibility(ACTIVITY_TYPE.CREATE)
                }
              />
            )
          }
        />
        {detail.visible && (
          <ManagementClaimDetail
            {...this.props}
            onRefresh={this.handleRefresh}
            isDisableSpesificField={isDisableSpesificField}
            formGroup={formGroupManagementClaim}
            visible={detail.visible}
            activityType={detail.activityType}
            initialValues={detail.data}
            onClickClose={this.handleDetailVisibility}
          />
        )}
        {filterVisible && (
          <ManagementClaimFilter
            {...this.props}
            visible={filterVisible}
            onClickClose={this.handleFilterVisibility}
            submitedFilter={submitedFilter}
            onSubmit={this.handleSubmitFilter}
          />
        )}
      </React.Fragment>
    );
  }
}
